import { render, staticRenderFns } from "./RadioSelectionCard.vue?vue&type=template&id=4b6064cc&scoped=true&lang=pug&"
import script from "./RadioSelectionCard.vue?vue&type=script&lang=js&"
export * from "./RadioSelectionCard.vue?vue&type=script&lang=js&"
import style0 from "./RadioSelectionCard.vue?vue&type=style&index=0&id=4b6064cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6064cc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VForm,VIcon,VSimpleTable})
